import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { validaCnpj } from 'app/utils/documento';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReceitaWsService {
  apiRoot: string = "https://receitaws.com.br/v1/cnpj/";
  

  constructor( private http: HttpClient) {}

  consulta(cnpj: any): Observable<any>  {
    if (cnpj != null && cnpj !== '') {
      cnpj = cnpj.replace(/\D/g, '' );
    }
    if (cnpj !== '') {
      if (validaCnpj(cnpj)) {
        let apiURL = this.apiRoot + cnpj;
        return this.http.jsonp(apiURL, "callback");
      }
    }
    return of({});
  }

}
